import { useEffect, useRef } from 'react';
import { getRememberedView } from '../ui/SavedViews';

interface ListHandle<K extends string> {
  searchParams: URLSearchParams;
  applyView: (query: string, viewKeys: readonly K[], opts?: { replace?: boolean }) => void;
}

/**
 * D1 "remembers the last view": when a list opens with none of its view keys
 * in the URL (the sidebar link, a bare `/leads`), apply the view the user
 * picked last on this list, else `fallbackQuery`. Runs once per visit, as a
 * history *replace*, so Back does not land on the bare URL. A deep link with
 * filters (`/quotes?status=draft`) is never overridden.
 */
export function useArrivalView<K extends string>(list: ListHandle<K>, viewKeys: readonly K[], listId: string, userId: string | undefined | null, fallbackQuery = '') {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (viewKeys.some((k) => list.searchParams.has(k))) return;
    const query = getRememberedView(listId, userId) ?? fallbackQuery;
    if (query) list.applyView(query, viewKeys, { replace: true });
    // Once, on arrival only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
